<template>
  <layout :show-profile="false">
    <div class="mt-12 sm:mt-6 px-4 sm:px-0 py-5">
      <div class="mt-12 max-w-sm mx-auto">

        <div class="px-4 pb-6">
            <p class="text-sm leading-5">Eingeloggt als
            <span class="text-sm leading-5 font-semibold text-gray-900">
              {{ $page.props.auth.user.name }}
            </span></p>
          </div>

        <div class="space-y-4">
          <Link
            :href="route('profile.index')"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white hover:bg-markencode-blue hover:text-white"
          >
            <span class="flex items-start text-sm font-medium"> Mein Profil</span>
          </Link>

          <Link
            :href="route('admin.partners.index')"
            v-if="$page.props.auth.user.is.admin"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white hover:bg-markencode-blue hover:text-white"
          >
            <span class="flex items-start text-sm font-medium"> Partner</span>
          </Link>

          <Link
            :href="route('admin.users.index')"
            v-if="$page.props.auth.user.is.admin"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white hover:bg-markencode-blue hover:text-white"
          >
            <span class="flex items-start text-sm font-medium"> User</span>
          </Link>

          <Link
            :href="route('admin.value-space-calculations.index')"
            v-if="$page.props.auth.user.can.view_value_space_calculations && false"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white hover:bg-markencode-blue hover:text-white"
          >
            <span class="flex items-start text-sm font-medium"> Werteräume-Log</span>
          </Link>

          <horizontal-divider />

          <Link
            :href="route('admin.questions.index')"
            v-if="$page.props.auth.user.is.admin"
            class="relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white hover:bg-markencode-blue hover:text-white"
          >
            <span class="flex items-start text-sm font-medium"> Fragen</span>
          </Link>
        </div>

        <a
          @click="logout"
          class="mt-16 relative block cursor-pointer rounded-lg border px-6 py-4 focus:outline-none sm:flex sm:justify-between bg-white text-gray-400 hover:bg-markencode-blue hover:text-white"
        >
          <span class="flex items-start text-sm font-medium"> Logout</span>
        </a>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import HorizontalDivider from '@/Shared/HorizontalDivider';

export default {
  components: {
    Layout,
    HorizontalDivider,
  },

  props: ['translations'],

  data() {
    return {};
  },

  methods: {
    logout() {
      this.$inertia.post('/logout', {});
    },
  },
};
</script>
